import starIcon from '../../../assets/dashboard_assets/star.png';

const MRP = 400;
const CREDITS_PER_LISTING = 50;

const getPerListing = (count) => {
    if (count <= 10) return 260;
    if (count <= 50) return 250;
    if (count <= 100) return 235;
    if (count <= 150) return 220;
    if (count <= 200) return 210;
    return 200;
};

const PACKS = [250, 500, 1000].map((credits) => {
    const listings = credits / CREDITS_PER_LISTING;
    const perListing = getPerListing(listings);
    const subtotal = listings * perListing;
    const mrpTotal = listings * MRP;
    const savings = mrpTotal - subtotal;
    const discountPct = Math.round(((MRP - perListing) / MRP) * 100);
    const perCredit = (subtotal / credits).toFixed(2);
    return { credits, listings, displayPrice: subtotal, savings, discountPct, perCredit, popular: credits === 500 };
});

const CreditPackCard = ({ credits, listings, displayPrice, savings, discountPct, perCredit, popular, onSelect }) => (
    <div className={`relative flex-1 px-5 py-8 rounded-xl flex flex-col items-center justify-between ${
        popular
            ? 'bg-white shadow-[0_0_174px_14px_rgba(96,146,200,0.26)] outline outline-2 outline-[#78B3F3]'
            : 'bg-white/80 shadow-[0_0_134px_14px_rgba(120,179,243,0.06)] outline outline-1 outline-[#D0E7FF]'
    }`}>
        {popular && (
            <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 px-3 py-0.5 bg-[#78B3F3] rounded-md shadow-sm">
                <span className="text-white text-[10px] font-semibold whitespace-nowrap">Most Popular</span>
            </div>
        )}
        <div className="flex flex-col items-center gap-5">
            <div className="flex items-center gap-2">
                <img src={starIcon} alt="credits" className="w-7 h-7" />
                <span className="text-[#3A3A3A] text-[30px] font-semibold font-sans">{credits.toLocaleString()}</span>
            </div>
            <span className="text-[#737373] text-sm font-normal font-sans -mt-3">Credits</span>
            <div className="flex flex-col items-center gap-1">
                <span className="text-[#3A3A3A] text-2xl font-semibold font-sans">₹{displayPrice.toLocaleString()}</span>
                <span className="text-[#737373] text-sm font-normal font-sans">₹{perCredit} per credit</span>
            </div>
            <div className="flex items-center gap-2">
                <span className="text-[#2E9E5C] text-sm font-bold font-sans">{discountPct}% off</span>
                <span className="text-[#2E9E5C] text-sm font-medium font-sans">Save ₹{savings.toLocaleString()}</span>
            </div>
        </div>
        <button
            onClick={() => onSelect(listings)}
            className={`w-full h-11 px-4 mt-6 rounded-lg flex justify-center items-center cursor-pointer transition-all duration-200 ${
                popular
                    ? 'bg-gradient-to-r from-[#2766AA] to-[#0752B0] hover:opacity-90'
                    : 'outline outline-[1.5px] outline-offset-[-1.5px] outline-[#2766AA] hover:bg-[#2766AA] group'
            }`}
        >
            <span className={`text-base font-medium font-sans ${
                popular ? 'text-white' : 'text-[#2766AA] group-hover:text-white'
            }`}>Buy Pack</span>
        </button>
        <span className="text-[#737373] text-xs font-medium font-sans mt-2">Prices exclusive of 18% GST</span>
    </div>
);

const ActionCards = ({ onSelectPack }) => (
    <div className="flex-1 px-4 pt-6 pb-6 bg-white/80 shadow-[0_0_134px_14px_rgba(120,179,243,0.06)] rounded-3xl outline outline-1 outline-[#D0E7FF] flex flex-col gap-4">
        <div className="flex flex-col gap-1">
            <h4 className="text-[#3A3A3A] text-xl font-medium font-sans mb-0">Buy more Credits</h4>
            <p className="text-[#737373] text-xs font-medium leading-5 font-sans mt-0">
                One-time purchase, no renewal. Credits never expire.
            </p>
        </div>
        <div className="flex gap-3 flex-1">
            {PACKS.map((pack) => (
                <CreditPackCard key={pack.credits} {...pack} onSelect={onSelectPack} />
            ))}
        </div>
    </div>
);

export default ActionCards;
